import ReactDOM from 'react-dom';

export default function cleanupTxpSettingsDialog() {
    const txpSettingsDialogWrapper = document.querySelector('.TxpSettingsDialogWrapper');
    if (txpSettingsDialogWrapper) {
        ReactDOM.unmountComponentAtNode(txpSettingsDialogWrapper);
        if (txpSettingsDialogWrapper.parentNode) {
            txpSettingsDialogWrapper.parentNode.removeChild(txpSettingsDialogWrapper);
        }
    }
}
